import { createApp } from "vue";
import FontAwesomeIcon from "./fontawesome-icons";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "../src/assets/index.css";

store.dispatch("auth/init");

createApp(App)
  .use(router)
  .use(store)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
